export const dirtyFlags = ref<Record<string, { save: string; cancel?: string }>>({})

const submittingFlags = new Map<string, Ref<boolean>>()

export async function saveAllDirtyForm() {
  const buttonIds = Object.keys(dirtyFlags.value)

  for (const buttonId of buttonIds) {
    document.getElementById(buttonId)?.click()
  }

  // vee-validate flips isSubmitting synchronously on submit, so this is already
  // true for every form that actually started saving
  const pending = buttonIds
    .map((buttonId) => submittingFlags.get(buttonId))
    .filter((flag): flag is Ref<boolean> => !!flag)

  await until(computed(() => pending.every((flag) => !flag.value))).toBe(true, { timeout: 30_000 })
}

export function clearAllDirtyForm() {
  for (const { cancel } of Object.values(dirtyFlags.value)) {
    if (!cancel) continue
    document.getElementById(cancel)?.click()
  }
  dirtyFlags.value = {}
}

export function useIsAnyFormDirty({
  saveButtonId,
  cancelButtonId,
  isDirty,
  isSubmitting,
}: {
  saveButtonId: string
  cancelButtonId?: string
  isDirty: Ref<boolean>
  isSubmitting: Ref<boolean>
}) {
  submittingFlags.set(saveButtonId, isSubmitting)

  watch(
    isDirty,
    () => {
      if (isDirty.value) {
        dirtyFlags.value[saveButtonId] = { save: saveButtonId, cancel: cancelButtonId }
      }
      else {
        delete dirtyFlags.value[saveButtonId]
      }
    },
    { immediate: true },
  )

  function remove() {
    delete dirtyFlags.value[saveButtonId]
    submittingFlags.delete(saveButtonId)
  }

  return {
    remove,
  }
}
